import {
  AxiosDeleteRequestOptions,
  AxiosGetRequestOptions,
  AxiosPostRequestOptions,
} from '@/package';
import type { StorageApi } from '@/type';
import { apiOf } from '@/util';

/**
 * @description Use only _s3_
 */
export const createPresignURL = apiOf<
  StorageApi.CreatePresignURL.Request,
  StorageApi.CreatePresignURL.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/storage/presignURL' }));

export const downloadDirectory = apiOf<
  StorageApi.DownloadDirectory.Request,
  StorageApi.DownloadDirectory.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/storage/download' }));

/**
 * @description Use only _s3_
 */
export const getList = apiOf<
  StorageApi.GetList.Request,
  StorageApi.GetList.Response
>(new AxiosGetRequestOptions({ url: '/v1/miri/storage' }));

/**
 * @description Use only _s3_
 */
export const remove = apiOf<
  StorageApi.Remove.Request,
  StorageApi.Remove.Response
>(
  new AxiosDeleteRequestOptions({
    url: '/v1/miri/storage',
  }),
);

export const linkConnection = apiOf<
  StorageApi.LinkConnection.Request,
  StorageApi.LinkConnection.Response
>(new AxiosPostRequestOptions({ url: '/v1/miri/storage/link/verify' }));
